import dayjsLib from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import 'dayjs/locale/it'
import 'dayjs/locale/en'
import 'dayjs/locale/de'
import 'dayjs/locale/ko'
import 'dayjs/locale/ar'

// Extend once at module load so `dayjs.tz(...)` is always available.
dayjsLib.extend(utc)
dayjsLib.extend(timezone)
// Registered here rather than only in helpers/utils, so the `L` / `lll` tokens
// work for anyone importing dayjs directly instead of by side effect.
dayjsLib.extend(localizedFormat)

/**
 * Formats an absolute instant for display, in `timeZone` when one is given.
 *
 * The zone is what makes an event timestamp read the same for everyone. The
 * instant is absolute, so without it the viewer's browser decides the clock, and
 * a team spread across countries reads a different time than the market did.
 * Pass the event's `time_zone` for anything that happened at an event: arrival
 * times, close instants, capture and export provenance.
 *
 * Not for naive wall-clock values (`'2026-07-09T18:00:00'`, no offset): those
 * are already local to the market, and converting them would move the hour. The
 * planned start/end times are the only such values; `formatStartTime` in the
 * marquee utils handles them.
 */
/**
 * @deprecated formatDate. Use `formatDate` from `@/dates` instead
 */
export const formatDate = (
	date: string | Date | undefined | null,
	formatType = 'YYYY-MM-DD',
	timeZone?: string | null
) => {
	if (!date) {
		return '-'
	}
	const parsed = dayjs(date)
	if (!parsed.isValid()) {
		return '-'
	}
	return (timeZone ? parsed.tz(timeZone) : parsed).format(formatType)
}

// we need to use a const to avoid barrel exports
const dayjs = dayjsLib

export { dayjs }
